export default "__VITE_ASSET__CWnncrne__"